import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { AppSettings } from "../settings/app.settings";
import { HttpClientService } from "../utilities/http.client";
import { ILanguageModel } from "../models/language.model";
import { ICountryModel } from "../models/country.model";
import { IdValueItem, IIdValueItem } from '../models/id-value-item.model';
import { map } from "rxjs/internal/operators/map";

@Injectable()
export class CommonService {
  private _sampleQuotaModes = new Array<IIdValueItem>();

  get sampleQuotaModes() { return this._sampleQuotaModes; }

  set sampleQuotaModes(sampleQuotaModes: Array<IIdValueItem>) {
    this._sampleQuotaModes = sampleQuotaModes.slice();
}

  private _firstClickPriorityOptions = new Array<IIdValueItem>();

  get firstClickPriorityOptions() { return this._firstClickPriorityOptions; }

  set firstClickPriorityOptions(firstClickPriorityOptions: Array<IIdValueItem>) {
    this._firstClickPriorityOptions = firstClickPriorityOptions.slice();
  }

	private urls = {
		"getLocales": this.appSettings.CommonApiPath + "locales",
		"getCountries": this.appSettings.CommonApiPath + "countries",
    "getSampleQuotaModes": this.appSettings.AdminApiPath + "getSampleQuotaModes",
    "getFirstClickPriorityOptions": this.appSettings.AdminApiPath + "getFirstClickPriorityOptions",
    "getPanelIdByLocale": this.appSettings.CommonApiPath + "getPanelIdByLocale/{locale}"
	};

	constructor(
		private http: HttpClientService,
		private appSettings: AppSettings
	) { }

	getLocales(countryId: number = -1): Observable<ILanguageModel[]> {
		return this.http.getSubscription(this.urls["getLocales"], { countryId: countryId });
	}

	getCountries(): Observable<ICountryModel[]> {
		return this.http.getSubscription(this.urls["getCountries"], { });
	}

  getSampleQuotaModes = (): Observable<Array<IIdValueItem>> =>
  this.http
    .getSubscription(this.urls["getSampleQuotaModes"])
    .pipe(
      map((sampleQuotaModes: Array<IdValueItem>) => sampleQuotaModes
      .map((sampleQuotaMode: IIdValueItem) => new IdValueItem(sampleQuotaMode.id, sampleQuotaMode.value))
      ));

  getFirstClickPriorityOptions = (): Observable<Array<IIdValueItem>> =>
    this.http
      .getSubscription(this.urls["getFirstClickPriorityOptions"])
      .pipe(
        map((firstClickPriorityOptions: Array<IdValueItem>) => firstClickPriorityOptions
          .map((firstClickPriorityOptions: IIdValueItem) => new IdValueItem(firstClickPriorityOptions.id, firstClickPriorityOptions.value))
        ));

  getPanelIdByLocale(locale: string = ""): Observable<number> {
    return this.http.getSubscription(this.urls["getPanelIdByLocale"], { "locale": locale });
  }

}
